import {
  baseClasses,
  errorBorder,
  normalBorder,
  sizeClasses,
} from '@/components/base/form/input/styles';
import { clsx } from 'clsx';
import {
  type ComponentPropsWithoutRef,
  type ReactNode,
  forwardRef,
  useRef,
} from 'react';
import { mergeRefs } from 'react-merge-refs';

export interface InputProps
  extends Omit<ComponentPropsWithoutRef<'input'>, 'size'> {
  error?: boolean;
  size?: 'default' | 'small';
  prepend?: ReactNode;
  append?: ReactNode;
  inputClassName?: string;
  testId?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      error,
      size = 'default',
      className,
      prepend,
      append,
      inputClassName,
      testId,
      ...props
    },
    forwardedRef,
  ) => {
    const ref = useRef<HTMLInputElement>(null);

    return (
      <div
        className={clsx(
          baseClasses,
          sizeClasses[size],
          error ? errorBorder : normalBorder,
          className,
        )}
        onClick={() => ref.current?.focus()}
      >
        {prepend}
        <input
          {...props}
          data-testid={testId}
          ref={mergeRefs([forwardedRef, ref])}
          className={clsx('w-full focus:outline-none', inputClassName)}
        />
        {append}
      </div>
    );
  },
);

Input.displayName = 'Input';

export default Input;
